<template>
    <label class="file-select btn-block" :class="{ 'disabled': disabled }">
        <span v-if="value" class="file-name"><i class="fal fa-upload mr-3"></i> {{value.name}}</span>
        <div v-if="!value" class="select-button btn btn-dark btn-block">
            <span>Selecteer bestand <i class="fal fa-upload ml-2"></i></span>
        </div>
        <input type="file" accept="image/*" @change="handleFileChange" :disabled="disabled"/>
    </label>
</template>

<script>

    export default {
        props: {
            value: File,
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleFileChange(e) {

                this.$emit('input', e.target.files[0])
            }
        }
    }
</script>

<style lang="scss" scoped>
    label {
        margin-bottom: 0;
    }
    .file-select > input[type="file"] {
        display: none;
    }
    .file-select {
        .select-button {
            white-space: nowrap;
            padding: 1.1rem 1.5rem;
        }

        .file-name {
            font-weight: 400;
            display: block;
            margin-top: 10px;

            &:hover {
                cursor: pointer;
                color: #00A192;;
            }
        }
    }
    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }
</style>